import { SearchResponseType } from '@dfl/react-security';
import { IOrder } from '../interfaces/IOrder';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { isBoolean } from 'lodash';
import { ORDER_STATUS_TYPE_ENUM } from 'modules/sales/settings/order-status/constants';

// no row style in this status
const END_ORDER = [ORDER_STATUS_TYPE_ENUM.COMPLETED];

const parser = (order: IOrder & { dflRowClass: string }) => {
  const now = new Date();
  const deliveryDueDate = order?.shipping.deliveryDueDate;
  const deliveryDueDateParsed = deliveryDueDate ? parseISO(deliveryDueDate) : null;

  /* no delivery due date */
  if (!deliveryDueDateParsed) return order;

  // is not paid
  if (isBoolean(order?.payment?.paid) && !order.payment.paid) return order;

  // complete order
  if (END_ORDER.includes(order?.status?.type as ORDER_STATUS_TYPE_ENUM)) return order;

  // row styles by delivery risk level (positive = days remaining, negative = days overdue)
  const daysUntilDue = differenceInCalendarDays(deliveryDueDateParsed, now);

  if (daysUntilDue <= -4) order.dflRowClass = 'row-critical';
  else if (daysUntilDue <= -3) order.dflRowClass = 'row-severe';
  else if (daysUntilDue <= -2) order.dflRowClass = 'row-late';
  else if (daysUntilDue <= 1) order.dflRowClass = 'row-warning';

  return order;
};

export const parserManyOrders = (data: SearchResponseType<any>): SearchResponseType<any> => {
  data.data = data.data.map(parser);
  return data;
};
